export default __webpack_public_path__ + "static/media/img_introduce_in_detail_2.71bf4c82.png";